import { render, staticRenderFns } from "./DutyActivities.vue?vue&type=template&id=06f4867b&scoped=true&"
import script from "./DutyActivities.vue?vue&type=script&lang=js&"
export * from "./DutyActivities.vue?vue&type=script&lang=js&"
import style0 from "./DutyActivities.vue?vue&type=style&index=0&id=06f4867b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f4867b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCardText,VDivider,VExpandTransition})
